<template>
  <span>
    <sidebar-module-info
      ref="sidebarModuleInfo"
      module-name="scada"
      permissions-path="SCADA"
      :filtered-attributes="['id']"
      :get-object="getScadaObject"
      :handle-object-editing="handleScadaEditing"
      :has-assigned-objects="false"
      :has-deleting-objects="false"
      :has-new-objects="false"
      :has-url-button="true"
      :init-gets="initGets"
      :inputs="inputs"
      :module-links="scadaLinks"
      :module-objects="scada"
      :zoom-to-object="zoomToScada"
      has-back-button
      has-basic-attributes
    >
      <template #measurements="scope">
        <sidebar-measurements-list v-bind="scope" />
      </template>
    </sidebar-module-info>
  </span>
</template>

<script>
import { call, get } from 'vuex-pathify';

import SidebarMeasurementsList from '@/components/SidebarMeasurementsList';
import SidebarModuleInfo from '@/components/SidebarModuleInfo';

export default {
  name: 'ScadaInfo',
  components: { SidebarMeasurementsList, SidebarModuleInfo },
  computed: {
    scada: get('scada/scada'),
    scadaLinks: get('scada/scadaLinks'),
    scadaMeasurements: get('scada/scadaMeasurements'),
    currentScadaId() {
      return this.$route.params.fid;
    },
    inputs() {
      return {
        new: [],
        edit: [
          {
            name: 'measurements',
            hasDivider: true,
            hasIconColumn: true,
            hasNameColumn: false,
            cols: '12',
            measurements: this.scadaMeasurements[this.currentScadaId],
          },
        ],
      };
    },
  },
  methods: {
    editScada: call('scada/editScada'),
    getScada: call('scada/getScada'),
    getScadaFeature: call('scada/getScadaFeature'),
    getScadaMeasurements: call('scada/getScadaMeasurements'),
    zoomToScada(layerId, layerGroup, featureId) {
      this.$root.$emit('zoomToFeature', layerId, layerGroup, featureId);
    },
    async getScadaObject(id) {
      const r = await this.getScadaFeature(id);
      const object = {
        ...r.properties,
        ...{ id: r.id },
        ...{ geometry: { ...r.geometry, ...{ crs: r.crs } } },
      };
      return object;
    },
    async handleScadaEditing(payload) {
      const scada_id = payload.id;
      delete payload.id;
      const feature = {
        ...payload,
      };
      await this.editScada({ scada_id, feature });
    },
    async initGets() {
      await this.getScadaMeasurements(this.currentScadaId);
    },
  },
};
</script>
